/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Button, Select } from "antd";
import { Modal, Radio } from "antd";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
import Axios from "../../../api/Axios";
const { Option } = Select;
const FilterCustomers = ({
  visible,
  naicsRes,
  setNaicsRes,
  applications,
  selectedApplications,
  setSelectedApplications,
  selectedNaics,
  setSelectedNaics,
  handleApply,
  handleCancel,
  handleStatusChange,
  status,
  ResetFields,
  customerToClient,
  setCustomerToClient,
}) => {
  //console.log(visible);
  //console.log(applications);
  const handleNaicsLoad = async () => {
    const response = await Axios.get(`organizationlist/?is_parent=True`);
    //console.log(response);
    setNaicsRes(response.data);
  };
  useEffect(() => {
    handleNaicsLoad();
  }, [visible]);
  // eslint-disable-next-line no-unused-vars
  const handleNaicsSearch = async (value) => {
    //console.log(value);
    if (value.length >= 2) {
      const response = await Axios.get(
        `organizationlist/?is_parent=True&search=${value}`
      );
      //console.log(response);
      setNaicsRes(response.data);
    } else {
      setNaicsRes([]);
    }
  };

  const handleNaicsSelect = (value) => {
    //console.log(value);
    setSelectedNaics(value);
  };
  const handleApplicationsSelect = (value) => {
    //console.log(value);
    setSelectedApplications(value);
  };
  const handleCustomerClient = (e) => {
    //console.log(e.target.value, "setCustomerToClient");
    setCustomerToClient(e.target.value);
  };
  const handleNaicsBlur = () => {
    if (!selectedNaics) {
      setSelectedNaics("");
    }
  };

  return (
    <Modal
      title={<p className="modal-heading">FILTER CUSTOMERS</p>}
      onOk={handleApply}
      open={visible}
      footer={null}
      onCancel={handleCancel}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <p className="my-form-lables">STATUS : </p>
        <Radio.Group
          onChange={handleStatusChange}
          value={status[0]}
          className="custom-checkbox-group"
          style={{
            paddingLeft: "1rem",
            fontWeight: "600",
          }}
        >
          <Radio value="True">Active</Radio>
          <Radio value="False">Inactive</Radio>
        </Radio.Group>
      </div>

      <div style={{ display: "flex", alignItems: "center", padding: "1rem" }}>
        <p className="my-form-lables">PARENT CLIENT : </p>
        <Select
          showSearch
          placeholder="Enter NAICS Code"
          filterOption={false}
          className="my-form-input"
          style={{
            width: "27rem",
            marginLeft: "1rem",
            borderRadius: "0.7rem",
            borderColor: "#818589",
          }}
          onSearch={handleNaicsSearch}
          onSelect={handleNaicsSelect}
          onBlur={handleNaicsBlur}
          value={selectedNaics}
        >
          {naicsRes?.map((naics) => (
            <Option key={naics.id} value={naics.id}>
              {`${naics.name}`}
            </Option>
          ))}
        </Select>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "1rem",
        }}
      >
        <p className="my-form-lables">APPLICATIONS : </p>
        <Select
          showSearch
          placeholder="Select Applications"
          className="my-form-input"
          style={{
            width: "27.5rem",
            marginLeft: "1rem",
            borderRadius: "0.7rem",
            borderColor: "#818589",
          }}
          onChange={handleApplicationsSelect}
          value={selectedApplications}
          mode="multiple"
        >
          {applications?.map((naics) => (
            <Option key={naics.id} value={naics.id}>
              {`${naics.name}`}
            </Option>
          ))}
        </Select>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "1rem",
          marginBottom: "2rem",
        }}
      >
        <p className="my-form-lables">Customer Turned Into Client : </p>
        <Radio.Group
          onChange={handleCustomerClient}
          value={customerToClient}
          className="custom-checkbox-group"
          style={{
            paddingLeft: "1rem",
            fontWeight: "600",
          }}
        >
          <Radio value={false}>No</Radio>
          <Radio value={true}>Yes</Radio>
        </Radio.Group>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          height: "2rem",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Button key="back" onClick={handleCancel}>
          <CloseOutlined />
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={ResetFields}
          style={{ marginLeft: "1rem" }}
        >
          {/* <CloseOutlined /> */}
          Reset
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            background: "#f58029",
            fontWeight: "600",
            marginLeft: "1rem",
          }}
          onClick={handleApply}
          className="save-update-btn"
        >
          Apply
          <FormOutlined />
        </Button>
      </div>
    </Modal>
  );
};

export default FilterCustomers;
